//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {},
    mixins: [],
    data() {
        return {
            tabIndex: 0,
            purview: [],
            normalPurview: [
                '能及时收到长者监护手表的自动监测报警。',
                '能及时收到长者的手动报警。',
                '可查看报警时长者的心率、实时位置等信息。',
                '可与其他守护人就每条报警进行文字、图片和语音 交流。',
                '可随时与长者高清视频通话。',
                '可浏览“来邦健康小巴士”了解健康知识。'
            ],
            vipPurview: [
                '每天早晨，能收到长者昨晚的睡眠质量、夜尿次数 等统计报告。 ',
                ' 每天夜晚，能收到长者当天的报警记录、离家记 录、大解记录、在床记录、心率数据、手表离手 记录等统计报告。',
                '每隔一段时间，能收到长者的所在位置等监护数据。',
                '能及时获知长者离家或回家动态。可随时查找长者的实时位置。',
                '可随时查看长者的当天活动轨迹。'
            ]
        };
    },
    methods: {
        // 切换菜单
        changeTab(index_) {
            this.tabIndex = index_;
            if (index_ == 0) {
                this.purview = this.normalPurview;
            } else {
                this.purview = this.vipPurview;
            }
        }
    },
    mounted() {
        this.purview = this.normalPurview;
    }
};



// WEBPACK FOOTER //
// ./src/components/member/vipEquity.vue